<template>
	<InPageNav
		:options="[
					{
						text : 'Templates',
						path : '/',
					},
					{
						text : 'Saved Configs',
						path : '/configs',
					},
				]"
	/>
</template>

<script>

	import InPageNav from "../components/InPageNav.vue";

	export default {
		props : [
			'org',
		],
		components : {
			InPageNav,
		},
	}

</script>